import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CalendarClock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import SocialAuthButtons from "@/components/SocialAuthButtons";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Giriş başarılı");
      nav(u.role === "super_admin" ? "/admin" : "/panel");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grain-bg flex items-center justify-center p-5">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <div className="w-9 h-9 rounded-lg bg-primary flex items-center justify-center">
            <CalendarClock className="w-5 h-5 text-primary-foreground" />
          </div>
          <span className="font-display font-bold text-2xl">365Rez</span>
        </Link>
        <div className="rounded-xl border border-border bg-card p-8 shadow-sm">
          <h1 className="text-2xl font-bold mb-1">Giriş Yap</h1>
          <p className="text-sm text-muted-foreground mb-6">İşletme panelinize erişin</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email">E-posta</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                required className="h-12 mt-1.5" placeholder="ornek@isletme.com" data-testid="login-email-input" />
            </div>
            <div>
              <Label htmlFor="password">Şifre</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                required className="h-12 mt-1.5" placeholder="••••••••" data-testid="login-password-input" />
            </div>
            <Button type="submit" className="w-full h-12 rounded-lg" disabled={loading} data-testid="login-submit-btn">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Giriş Yap"}
            </Button>
          </form>
          <SocialAuthButtons />
          <p className="text-sm text-center text-muted-foreground mt-6">
            Hesabınız yok mu?{" "}
            <Link to="/kayit" className="text-primary font-semibold hover:underline">Kayıt olun</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
